const dataLayer = (<any>window).dataLayer || [];
const datalayerTrack = (params: []) => {
  dataLayer.push({...params});
}

export { datalayerTrack };
